export const cases = [
  {
    id: "1",
    partnerName: "Санаторий «Ай-Петри»",
    type: "Санаторий",
    challenge: "Нехватка квалифицированных администраторов в высокий сезон, длинные очереди на ресепшен",
    solution: "Подобрали 8 опытных администраторов, знакомых со спецификой санаторно-курортного сегмента, организовали сменный график",
    result: "Время ожидания заезда сократилось с 40 до 7 минут, оценка персонала на Booking выросла с 7.8 до 9.2",
    imageUrl: "/readdy/295eb633d1d9f4535ccd388e763499c4.jpeg",
  },
  {
    id: "2",
    partnerName: "Отель «Рассветы Закаты»",
    type: "Отель",
    challenge: "Высокая текучка персонала ресепшен, гости жаловались на неуютную атмосферу при заезде",
    solution: "Провели отбор кандидатов с фокусом на эмпатию и стрессоустойчивость, организовали двухнедельный тренинг по стандартам гостеприимства",
    result: "Текучка снизилась на 65%, оценка встречи гостей выросла с 7.4 до 9.5 по отзывам на всех платформах",
    imageUrl: "/readdy/4e5e3babf9c0b4aa943180bfb484c62a.jpeg",
  },
  {
    id: "3",
    partnerName: "Санаторий «Южное взморье»",
    type: "Санаторий",
    challenge: "Персонал не справлялся с пиковой загрузкой в летний сезон, участились жалобы на обслуживание",
    solution: "Укомплектовали штат на 140% от базовой нормы, внедрили ротацию смен и систему контроля качества",
    result: "Жалобы на персонал снизились на 80%, объект получил статус «Лучший санаторий сезона» по версии сайта партнёра",
    imageUrl: "/readdy/13850f33adb728e22247e161a4c25943.jpeg",
  },
  {
    id: "4",
    partnerName: "Отель «PION»",
    type: "Отель",
    challenge: "Открытие нового отеля без готовой команды, срочно требовался полный штат ресепшен и администраторов",
    solution: "Закрыли все вакансии за 10 дней: подобрали, проверили и вывели на объект 5 сотрудников до открытия",
    result: "Отель открылся в срок, первые отзывы гостей о персонале — 9.3 из 10 на Booking.com",
    imageUrl: "/readdy/d62c370c80f6bf09aade8094e967820f.jpeg",
  },
  {
    id: "5",
    partnerName: "Отель «Фандоринъ All inclusive»",
    type: "Отель",
    challenge: "Формат All inclusive требовал повышенного внимания персонала, сотрудники не справлялись с потоком запросов",
    solution: "Отобрали специалистов с опытом работы в All inclusive сегменте, провели обучение стандартам полного обслуживания",
    result: "Удовлетворённость гостей выросла на 40%, повторные визиты увеличились на 28% за сезон",
    imageUrl: "/readdy/d7dc360151391750557449161ec62158.jpeg",
  },
  {
    id: "6",
    partnerName: "Пансионат «Приветливый берег»",
    type: "Пансионат",
    challenge: "Нестабильный состав смен, гости каждый раз сталкивались с разным уровнем сервиса",
    solution: "Сформировали постоянный пул сотрудников с едиными стандартами работы, внедрили регулярные аттестации",
    result: "Единый уровень сервиса во всех сменах, рейтинг на платформах вырос с 8.1 до 9.4 за 3 месяца",
    imageUrl: "/readdy/7a874e54996d8a8d77b0e504ba64ca32.jpeg",
  },
  {
    id: "7",
    partnerName: "Пансионат «Геленджикская бухта»",
    type: "Пансионат",
    challenge: "Ручной учёт заселения приводил к ошибкам и двойным бронированиям в пик сезона",
    solution: "Обучили персонал работе с PMS-системой, выстроили чёткий документооборот при заезде и выезде гостей",
    result: "Двойных бронирований — 0, потери от ошибок снизились на 100%, доход вырос на 18%",
    imageUrl: "/readdy/3dbdfe198629142acf379c417bba4526.jpeg",
  },
  {
    id: "8",
    partnerName: "Санаторий «Им. Горького»",
    type: "Санаторий",
    challenge: "Сложности с прохождением проверок по СМК, персонал не знал требования стандартов",
    solution: "Разработали полный комплект документации СМК, провели обучение всех сотрудников ресепшен и обслуживающего персонала",
    result: "Проверка СМК пройдена с первого раза без замечаний, объект получил лицензию на расширенный перечень услуг",
    imageUrl: "/readdy/2f34ac88dbd8176e9ba5e986dd613dd7.jpeg",
  },
  {
    id: "9",
    partnerName: "Санаторий «Виктория»",
    type: "Санаторий",
    challenge: "Молодые сотрудники не умели работать с возрастной аудиторией, были жалобы на грубость",
    solution: "Провели специальные тренинги по общению с гостями старшего возраста, ввели систему наставничества",
    result: "Жалобы на персонал сократились на 90%, объект попал в топ-5 санаториев региона по версии гостей",
    imageUrl: "/readdy/7d170ee745f522d32e1fd953be75d23c.jpeg",
  },
  {
    id: "10",
    partnerName: "Гостиничный комплекс «Новый Свет»",
    type: "Гостиничный комплекс",
    challenge: "Расширение комплекса потребовало быстрого найма сразу 15 сотрудников разных должностей",
    solution: "Провели массовый подбор за 2 недели: администраторы, хостес, специалисты по бронированию — все позиции закрыты",
    result: "Открытие нового корпуса состоялось в срок, первый сезон прошёл без кадровых инцидентов",
    imageUrl: "/readdy/26c1b81f7c132e477a19789379b3bda0.jpeg",
  },
  {
    id: "11",
    partnerName: "Гостевой дом «Скарлетт»",
    type: "Гостевой дом",
    challenge: "Небольшой объект не мог позволить себе штатного HR, поиск сотрудников занимал месяцы",
    solution: "Взяли на себя весь процесс подбора: от размещения вакансий до финального собеседования и оформления",
    result: "Два администратора закрыты за 5 дней, сэкономлено более 3 месяцев времени владельца",
    imageUrl: "/readdy/8861e8b7471e1cc92e6f4070ebdc67a1.jpeg",
  },
  {
    id: "12",
    partnerName: "Хостел R.E.d.",
    type: "Хостел",
    challenge: "Высокая текучка среди молодых сотрудников, администраторы уходили после 1–2 месяцев работы",
    solution: "Пересмотрели профиль кандидата: сделали акцент на мотивацию и лояльность, улучшили онбординг",
    result: "Средний срок работы сотрудника вырос с 1.5 до 8 месяцев, затраты на найм снизились на 60%",
    imageUrl: "/readdy/06f24b72a51c3c9db86eeacd4b165d37.webp",
  },
  {
    id: "13",
    partnerName: "Хостел ArtCapsule",
    type: "Хостел",
    challenge: "Арт-концепция хостела требовала особых сотрудников — творческих, коммуникабельных и энергичных",
    solution: "Разработали нестандартные критерии отбора, нашли кандидатов с опытом в творческих и событийных проектах",
    result: "Команда стала частью бренда хостела, гости отмечают уникальную атмосферу и живое общение с персоналом",
    imageUrl: "/readdy/06c0020883a3bf53006ee8017738e1b7.webp",
  },
];